import { render, staticRenderFns } from "./CrearVenta.vue?vue&type=template&id=4c53d1c2&"
import script from "./CrearVenta.vue?vue&type=script&lang=js&"
export * from "./CrearVenta.vue?vue&type=script&lang=js&"
import style0 from "./CrearVenta.vue?vue&type=style&index=0&id=4c53d1c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports